/*
 * OZ 2026-10-22: the Trustpilot reviews band's arrows (snippets/oz-pdp-reviews.liquid), on every page that holds a band:
 * the product page, the Apple hub, the "OZ Reviews" section and the sell page's reviews. Loaded by layout/theme.liquid
 * only when the page has one.
 * 2026-10-23: server-rendered. Every review figure and card, the rating line, the trust bar and the counts are printed
 * by Liquid from the shop metafield oz_reviews.feed (the Oz_Reviews Worker keeps it current from Trustpilot), so this
 * fetches nothing and changes no content. It only moves the row and hides the arrows where every card already fits.
 */
(function () {
  'use strict';

  // The review row's arrows (oz-reviews.css "The cards"): each moves a page, as many cards as are in view, and is
  // disabled at its own end; a card past the edge of the cards in view fades out so none peeks into the bleed.
  function setUpRail(band) {
    var list = band.querySelector('[data-oz-revs-cards]');
    var prev = band.querySelector('.oz-revs__nav--prev');
    var next = band.querySelector('.oz-revs__nav--next');
    if (!list || !prev || !next || list.dataset.ozRail) { return; }
    list.dataset.ozRail = 'true';
    function bleed() { return parseFloat(getComputedStyle(list).paddingLeft) || 0; }
    function step() {
      var a = list.children[0];
      var b = list.children[1];
      return a && b ? b.offsetLeft - a.offsetLeft : list.clientWidth;
    }
    function page() {
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      var s = step();
      return Math.max(1, Math.round((list.clientWidth - 2 * bleed() + gap) / s)) * s;
    }
    function ends() {
      var max = list.scrollWidth - list.clientWidth;
      prev.hidden = next.hidden = max <= 2;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= max - 2;
      var box = list.getBoundingClientRect();
      var from = box.left + bleed();
      var to = box.right - bleed();
      Array.prototype.forEach.call(list.children, function (card) {
        var r = card.getBoundingClientRect();
        var off = r.right <= from + 1 || r.left >= to - 1;
        if (card.classList.contains('is-off') !== off) { card.classList.toggle('is-off', off); }
      });
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -page() }); });
    next.addEventListener('click', function () { list.scrollBy({ left: page() }); });
    list.addEventListener('scroll', ends, { passive: true });
    window.addEventListener('resize', ends);
    ends();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-oz-revs]'), setUpRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
